import React from 'react';
import LoaderImage from '../../../../img/mob_logo.png';
const Loader = () => {
	return (
        <>
             <tbody className='loader_wrapper'>
                
                <tr>
                    <td colSpan={5}>
                        <div className="loading_wrp">
                            <img src={LoaderImage} alt='isloading' width={30} height={50}/>
                        </div>
                    </td>
                </tr>
            </tbody>
       
        </>
	);
};

export default Loader;